/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/auth/login')
    },
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home'),
          meta: {auth: true}
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import('./views/user/ShowProfile'),
          meta: {auth: true}
        },
        {
          path: '/students',
          name: 'students',
          component: () => import('./views/students/StudentsList'),
          meta: {auth: true, role: 'MODERATOR'}
        },
        {
          path: '/students/create',
          name: 'create_students',
          component: () => import('./views/students/CreateStudent'),
          meta: {auth: true, role: 'MODERATOR'}
        },
        {
          path: '/students/edit/:id',
          name: 'edit_student',
          component: () => import('./views/students/EditStudent'),
          meta: {auth: true, role: 'MODERATOR'}
        },
        {
          path: '/drivers',
          name: 'drivers',
          component: () => import('./views/drivers/DriversList'),
          meta: {auth: true, role: 'MODERATOR'}
        },
        {
          path: '/device_trips/:id',
          name: 'device_trips',
          component: () => import('./views/drivers/DeviceTrips'),
          meta: {auth: true, role: 'MODERATOR'}
        },
        {
          path: '/drivers/create',
          name: 'create_driver',
          component: () => import('./views/drivers/CreateDriver'),
          meta: {auth: true, role: 'MODERATOR'}
        },
        {
          path: '/drivers/edit/:id',
          name: 'edit_driver',
          component: () => import('./views/drivers/EditDriver'),
          meta: {auth: true, role: 'MODERATOR'}
        },
        {
          path: '/tasks',
          name: 'tasks',
          component: () => import('./views/tasks/TasksList'),
          meta: {auth: true, role: 'MODERATOR'}
        },
        {
          path: '/tasks/:id',
          name: 'task_show',
          component: () => import('./views/tasks/TaskShow'),
          meta: {auth: true, role: 'MODERATOR'}
        },
        {
          path: '/services',
          name: 'services',
          component: () => import('./views/tasks/services/ServicesList'),
          meta: {auth: true, role: 'MODERATOR'}
        },
        {
          path: '/send_message',
          name: 'send_message',
          component: () => import('./views/messages/SendMessage'),
          meta: {auth: true, role: 'MODERATOR'}
        },
        {
          path: '/received_messages',
          name: 'received_messages',
          component: () => import('./views/messages/MessagesList'),
          meta: {auth: true}
        },
        {
          path: '/sent_messages',
          name: 'sent_messages',
          component: () => import('./views/messages/MessagesList'),
          meta: {auth: true}
        },
        {
          path: '/cohorts',
          name: 'cohorts',
          component: () => import('./views/cohorts/CohortsList'),
          meta: {auth: true, role: 'MODERATOR'}
        },
        // {
        //   path: '/test',
        //   name: 'test',
        //   component: () => import('./views/Test'),
        //   meta: {auth: true, role: 'MODERATOR'}
        // },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})


router.beforeEach((to, from, next) => {

  if (to.meta.role) {
    if (store.state.AppActiveUser.role === to.meta.role) {
      next();
      return
    }
    next('/404')
  }

  //check auth
  if (to.matched.some(record => record.meta.auth)) {
    if (store.state.AppActiveUser.userName) {
      next();
      return
    }
    next('/login')
  }

  next()

});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

export default router
